import './DateTimeFormatBuilder.scss'
import { ReactComponent as RemoveIcon } from '../../../../components/Common/BootstrapIcons/trash.svg';
import DateTimeFormatPicker from '../../../Common/DateTimeFormatPicker/DateTimeFormatPicker';
import iconTooltip from '../../../Common/BootstrapIcons/Tooltip/IconTooltip';
import React from 'react';
import dateTimeFormatHelper from '../../../../infrastructure/helpers/common/dateTimeFormatHelper';

interface Props {
    dataType: string;
    formats: string[];
    onChange: (formats: string[]) => void;
    isInlineMode?: boolean;
    maxCount?: number;
    defaultFormat?: string;
}

class DateTimeFormatBuilder extends React.Component<Props> {

    constructor(props: Props) {
        super(props);

        this.onAddClick = this.onAddClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onRemoveClick = this.onRemoveClick.bind(this);

        this.getItem = this.getItem.bind(this);
        this.getButton = this.getButton.bind(this);
    }

    onAddClick(): void {

        const last = this.props.formats[this.props.formats.length - 1];

        this.props.onChange(this.props.formats.concat([last || this.props.defaultFormat || '']));
    }

    onChange(i: number, value: string): void {

        this.props.formats[i] = value;

        this.props.onChange(this.props.formats);
    }

    onRemoveClick(i: number): void {

        this.props.formats.splice(i, 1);

        this.props.onChange(this.props.formats);
    }

    getItem(format: string, i: number, all: string[]): JSX.Element {

        return (
            <div key={i} className='display-flex'>
                <div>
                    {
                        all.length > 1 &&
                        <button className="transparent-button" onClick={() => this.onRemoveClick(i)} title={iconTooltip.remove}>
                            <RemoveIcon />
                        </button>
                    }
                </div>
                <div>
                    <DateTimeFormatPicker
                        dataType={this.props.dataType}
                        format={format}
                        onFormatChange={format => this.onChange(i, format)}
                        isInlineMode={!!this.props.isInlineMode} />
                </div>
            </div>
        );
    }

    getButton(): JSX.Element {

        if (this.props.maxCount &&
            this.props.formats.length >= this.props.maxCount) {
            return (<></>);
        }

        return (
            <button onClick={this.onAddClick} className="btn btn-light margin-top-10px-important">+ Format</button>
        );
    }

    render(): JSX.Element {

        return (
            <div className="date-time-format-builder">
                <div>{this.props.formats.map(this.getItem)}</div>
                {this.getButton()}
            </div >
        );
    }
}

export default DateTimeFormatBuilder;
